import { createRouter, createWebHistory } from 'vue-router';
import { pinAssetsToDeployment } from '../skewProtection';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// Re-assert this tab's Vercel skew pin before the route's chunk is fetched. `beforeEach` runs
// before Vue Router loads lazy route components, so the cookie names THIS tab's build by the time
// the request leaves — even if another tab on a newer build wrote the cookie meanwhile.
router.beforeEach(() => {
  pinAssetsToDeployment();
});

export default router;
